"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserFullName = exports.DEFAULT_CONTACT_EMAIL = void 0;
exports.DEFAULT_CONTACT_EMAIL = 'partnersupport@engine.tech';
var getUserFullName = function (user) {
    return (user && "".concat(user.firstName, " ").concat(user.lastName)) || '';
};
exports.getUserFullName = getUserFullName;
